import axios from "axios";
import { getAPIUrl } from "../config";

const api = axios.create({
  baseURL: getAPIUrl(),
});

const avatarService = {
  async getPhotos(page, size, tags, gender) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get("/v1/avatar-photos", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          size,
          tags,
          gender,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar imagens de avatares");
    }
  },
};

export default avatarService;
